import About from './about';
import Contact from './contact';
import Email from './email';
import Featured from './featured';
import Footer from './footer';
import Head from './head';
import Hero from './hero';
import Jobs from './jobs';
import Layout from './layout';
import Loader from './loader';
import Menu from './menu';
import Nav from './nav';
import Projects from './projects';
import Social from './social';

export {
  About,
  Contact,
  Email,
  Featured,
  Footer,
  Head,
  Hero,
  Jobs,
  Layout,
  Loader,
  Menu,
  Nav,
  Projects,
  Social,
};
